import { MyEventsView } from './MyEventsView'
export default MyEventsView
